import axios from "./axiosInstance";
import { PayrollGeneratePayload, PayrollApiResponse, PayrollsApiResponse, PayrollLinePayload } from "../types/payrollTypes";

export const generatePayroll = async (payload: PayrollGeneratePayload): Promise<PayrollsApiResponse> => {
    const response = await axios.post<PayrollsApiResponse>("/payrolls/generate-all", payload);
    return response.data;
};

export const getPayrolls = async (params: {
    page?: number;
    limit?: number;
    status?: string;
    staffId?: string;
}): Promise<PayrollsApiResponse> => {
    const response = await axios.get<PayrollsApiResponse>("/payrolls", { params });
    return response.data;
};


export const getMyPayrolls = async (params: {
    page?: number;
    limit?: number;
    status?: string;
}): Promise<PayrollsApiResponse> => {
    const response = await axios.get<PayrollsApiResponse>("/payrolls/my", { params });
    return response.data;
};

export const getPayrollById = async (payrollId: string): Promise<PayrollApiResponse> => {
    const response = await axios.get<PayrollApiResponse>(`/payrolls/${payrollId}`);
    return response.data;
};

export const updatePayrollStatus = async (payrollId: string, status: string): Promise<PayrollApiResponse> => {
    const response = await axios.patch<PayrollApiResponse>(`/payrolls/${payrollId}/status`, { status });
    return response.data;
};

export const addPayrollLine = async (payload: PayrollLinePayload): Promise<PayrollApiResponse> => {
    const response = await axios.post<PayrollApiResponse>(`/payrolls/lines`, payload);
    return response.data;
};  
